import { render, staticRenderFns } from "./edit-debit-note.vue?vue&type=template&id=6b6b982f&scoped=true"
import script from "./edit-debit-note.vue?vue&type=script&lang=js"
export * from "./edit-debit-note.vue?vue&type=script&lang=js"
import style0 from "./edit-debit-note.vue?vue&type=style&index=0&id=6b6b982f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b982f",
  null
  
)

export default component.exports